"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("form-heading", require("./Heading.vue").default);

exports.default = {
  props: ["type", "test", "url", "project", "disabled", "occasion", "userIsInOccasion", "autosaveEnabled", "autosavedResults", "autosaveUrl"],

  data: function data() {
    return {
      oldInput: [],
      errors: [],
      ready: false,
      previousAutosave: null,
      isSaving: false,
      isAutosaving: false,

      /**
       * Don't change the value of this key. It must be the same as config/covid.php
       */
      createCertificateName: "make_certificate",
      createCertificateBtn: "make_certificate_btn",

      /**
       * Test types that will calculate sum of all questions.
       * The last question is invisible for these test types
       */
      calcSummaryTestTypes: [52, 57]
    };
  },


  mixins: [require("../../mixins/UserOwns.js"), require("../../mixins/UserCan.js")],

  mounted: function mounted() {
    var _this = this;

    var requestData = this.$store.getters.pullRequestErrorsAndOldInputByAction("store-test-answers");
    this.errors = requestData.errors;
    this.oldInput = requestData.oldInput;

    this.ready = true;
    var vm = this;

    if (this.autosaveEnabled && this.canSaveResults) {
      setInterval(function () {
        if (_this.isSaving) {
          return;
        }

        var formValues = $(vm.$refs["test-form"]).serialize();

        // Don't save if user haven't changed anything.
        if (vm.previousAutosave === formValues) {
          return;
        }

        vm.previousAutosave = formValues;
        formValues = formValues.replace("_method=PUT", "_method=POST");
        _this.isAutosaving = true;
        vm.$toastr.info(vm.$t("tests.messages.starting_autosave"));

        axios.post(_this.autosaveUrl, formValues).then(function (response) {
          _this.isAutosaving = false;
          vm.$toastr.success(vm.$t("tests.messages.successful_autosave"));
        }).catch(function (error) {
          _this.isAutosaving = false;
          vm.$toastr.error(vm.$t("tests.messages.unsuccessful_autosave"));
        });
      }, 60000);

      if (!_.isEmpty(this.autosavedResults)) {
        vm.$toastr.info(vm.$t("tests.messages.autosave_applied"));
      }
    }
  },


  computed: {
    method: function method() {
      return this.test ? "PUT" : "POST";
    },
    getUrl: function getUrl() {
      return this.test ? this.url + "/" + this.test.id : this.url;
    },
    mappedErrors: function mappedErrors() {
      var type = this.type;

      return this.errors.map(function (error) {
        var fieldName = error.substring(error.indexOf("headings"), error.indexOf(" ", error.indexOf("headings")));
        var field = eval("type." + fieldName);

        error = error.indexOf("headings") === -1 ? error : error.replace(fieldName, field ? "\"" + field.name + "\"" : "");

        return error.replace(/(<([^>]+)>)/gi, "");
      });
    },
    canSaveResults: function canSaveResults() {
      return this.occasion === undefined || this.canUpdateOccasion && this.userIsInOccasion;
    },


    /**
     * Is test type calculate summary test type
     *
     * @returns {boolean}
     */
    isCalcSummaryTestType: function isCalcSummaryTestType() {
      return this.calcSummaryTestTypes.includes(this.type.id);
    }
  },

  methods: {
    submit: function submit(event) {
      if (event.target.name == this.createCertificateBtn) {
        document.getElementsByName(this.createCertificateName)[0].value = true;
      }

      if (this.isCalcSummaryTestType) {
        var sumAnswers = 0;

        document.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          sumAnswers += radio.checked ? +radio.value : 0;
        });

        document.querySelector(".form-control").value = sumAnswers;
      }

      this.isSaving = true;
      this.$refs["test-form"].submit();
    },
    visibleHeading: function visibleHeading(index) {
      var lastHeading = Object.keys(this.type.headings).length - 1;

      // Hide last question for "KEDS" test type:
      if (this.isCalcSummaryTestType && index === lastHeading) {
        return false;
      }

      return true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/TestForm.vue
// module id = eanh
// module chunks = 0 1